import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  FaPlane, 
  FaHotel, 
  FaHome, 
  FaCar, 
  FaCarSide,
  FaBars,
  FaTimes 
} from 'react-icons/fa';
import logo from '../assets/logo.jpg'; // Update the path to your logo

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Home', path: '/', icon: null },
    { name: 'Flight Booking', path: '/flight-booking', icon: FaPlane },
    { name: 'Hotel Booking', path: '/hotel-booking', icon: FaHotel },
    { name: 'Apartment Booking', path: '/apartment-booking', icon: FaHome },
    { name: 'Airport Pickup', path: '/airport-pickup', icon: FaCarSide },
    { name: 'Car Rental', path: '/car-rental', icon: FaCar },
  ];

  const isActivePath = (path) => location.pathname === path;

  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className="sticky top-0 z-50 bg-white/80 backdrop-blur-md shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-4">
            <img src={logo} alt="Yowa Travels Logo" className="w-12 h-12 object-contain rounded-full shadow-md" />
            <div>
              <h1 className="text-2xl font-semibold text-gray-800 tracking-tight">Yowa Travels</h1>
              <p className="text-sm text-green-600 font-medium">Your Journey, Our Priority</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {navigationItems.map((item) => {
              const IconComponent = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 text-sm font-medium ${
                    isActivePath(item.path)
                      ? 'bg-green-500 text-white shadow-md'
                      : 'text-gray-700 hover:text-green-600 hover:bg-green-100'
                  }`}
                >
                  {IconComponent && <IconComponent className="text-base" />}
                  {item.name}
                </Link>
              );
            })}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-green-100 transition"
          >
            {isMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <motion.div
          initial={false}
          animate={{ height: isMenuOpen ? 'auto' : 0 }}
          transition={{ duration: 0.3 }}
          className="lg:hidden overflow-hidden"
        >
          <nav className="py-4 space-y-2">
            {navigationItems.map((item) => {
              const IconComponent = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition duration-300 text-sm font-medium ${
                    isActivePath(item.path)
                      ? 'bg-green-500 text-white shadow-md'
                      : 'text-gray-700 hover:text-green-600 hover:bg-green-100'
                  }`}
                >
                  {IconComponent && <IconComponent className="text-lg" />}
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </motion.div>
      </div>
    </motion.header>
  );
};

export default Header;
